export const SPECIALIST_CATALOG = [
    {
        key: 'bom_dia',
        name: 'Bom dia',
        shortDescription: 'Seu dia reunido em um único olhar pela equipe de especialistas.',
        description: 'Reúno clima, agenda, decisões pendentes, contas, datas, notícias, horóscopo e lista de compras num resumo que você abre quando quiser começar o dia.',
        accentColor: '#F59E0B',
        theme: 'sun',
        lifecycle: 'available',
        mascot: { key: 'esp-bomdia-v2', name: 'Rotina' },
        ownerCommandExamples: ['Bom dia', 'Como está meu dia hoje?'],
        capabilities: [
            'Abre o dia com prioridades, lembretes e novidades reunidos.',
            'Você escolhe quais assuntos merecem aparecer.',
        ],
        friendlyRules: [
            'Seu resumo respeita suas escolhas e mostra apenas o que importa para a manhã.',
        ],
    },
    {
        key: 'horoscopo',
        name: 'Horóscopo & Mapa Astral',
        shortDescription: 'A previsão do seu dia com base no seu mapa de nascimento.',
        description: 'Reúne Sol, Lua, Ascendente e os movimentos do dia a partir dos seus dados de nascimento, com uma leitura pessoal para começar a manhã. Conteúdo de entretenimento.',
        accentColor: '#6D28D9',
        theme: 'sparkles',
        lifecycle: 'available',
        mascot: { key: 'esp-horoscopo', name: 'Nébula' },
        ownerCommandExamples: [
            'Como está meu dia hoje, astrologicamente?',
            'Sou compatível com esse contato?',
        ],
        capabilities: [
            'Mostra os pontos centrais do seu mapa de forma visual.',
            'Compara signos e destaca os movimentos mais marcantes do dia.',
        ],
        friendlyRules: [
            'Uma leitura leve para reflexão e entretenimento, sem substituir suas decisões.',
        ],
    },
    {
        key: 'noticias',
        name: 'Notícias do seu jeito',
        shortDescription: 'As notícias dos seus temas, resumidas em 3 linhas.',
        description: 'Você escolhe os assuntos e recebe os destaques do dia em poucas linhas, com contexto e caminho para ler a matéria completa.',
        accentColor: '#E15F2E',
        theme: 'newspaper',
        lifecycle: 'available',
        mascot: { key: 'esp-noticias', name: 'Informação' },
        ownerCommandExamples: ['O que saiu de notícia sobre tecnologia hoje?'],
        capabilities: [
            'Organiza os destaques pelos assuntos que você acompanha.',
            'Entrega resumos diretos com acesso à publicação original.',
        ],
        friendlyRules: ['Cada notícia mostra sua origem para você conferir e se aprofundar.'],
    },
    {
        key: 'contas',
        name: 'Dinheiro',
        shortDescription: 'O que entra, o que vence e quanto sobra no mês, sempre à mão.',
        description: 'Organizo os ganhos e as contas que você me contar e mostro o que entrou, o que vence e a sobra prevista do mês, sem acesso ao seu banco e sem movimentar dinheiro.',
        accentColor: '#16A34A',
        theme: 'invoice',
        lifecycle: 'available',
        mascot: { key: 'esp-contas', name: 'Dinheiro' },
        ownerCommandExamples: [
            'Caiu meu salário.',
            'Quais contas vencem essa semana?',
            'Quanto sobra no mês?',
        ],
        capabilities: [
            'Organiza ganhos e contas, avulsos e mensais.',
            'Mostra o que entrou, o que vence e a sobra prevista do mês.',
        ],
        friendlyRules: ['Nunca movimenta dinheiro e só altera o que você confirmar.'],
    },
    {
        key: 'mercado',
        name: 'Mercado financeiro',
        shortDescription: 'Acompanha os ativos que você escolher, sem palpitar sobre compra ou venda.',
        description: 'Reúne os ativos e moedas que você acompanha, mostra o movimento do dia e destaca quando uma variação merece seu olhar.',
        accentColor: '#0F766E',
        theme: 'chart',
        lifecycle: 'coming_soon',
        mascot: { key: 'esp-mercado', name: 'Índice' },
        ownerCommandExamples: ['Como fechou a bolsa hoje?', 'Como está o dólar?'],
        capabilities: [
            'Seus ativos favoritos em um painel claro.',
            'Destaques de variação e resumo do fechamento.',
        ],
        friendlyRules: ['Informação para acompanhar o mercado, sem indicar compra ou venda.'],
    },
    {
        key: 'clima',
        name: 'Secretário do Tempo',
        shortDescription: 'O clima do seu dia, e um aviso antes de sair de casa.',
        description: 'Mostra a previsão do dia na sua cidade e avisa antes de compromissos da agenda quando o tempo pode atrapalhar (chuva, calor extremo).',
        accentColor: '#0EA5E9',
        theme: 'cloud',
        lifecycle: 'available',
        mascot: { key: 'esp-clima', name: 'Bruma' },
        ownerCommandExamples: ['Vai chover hoje?', 'Preciso de guarda-chuva amanhã?'],
        capabilities: [
            'Mostra hoje e os próximos dias com leitura fácil.',
            'Ajuda a planejar roupa, deslocamento e compromissos.',
        ],
        friendlyRules: ['Você sempre vê de onde veio a previsão e quando ela foi atualizada.'],
    },
    {
        key: 'datas_importantes',
        name: 'Datas que importam',
        shortDescription: 'Aniversários e momentos especiais no seu calendário afetivo.',
        description: 'Reúno as datas que você cadastrou e os aniversários dos seus contatos, mostro quanto falta e deixo os próximos momentos sempre à vista.',
        accentColor: '#E11D48',
        theme: 'gift',
        lifecycle: 'available',
        mascot: { key: 'esp-datas', name: 'Lacinho' },
        ownerCommandExamples: ['Quem faz aniversário esse mês?'],
        capabilities: [
            'Linha do tempo anual e contagem regressiva.',
            'Reaproveita aniversários preenchidos nos contatos.',
        ],
        friendlyRules: [
            'A data vem sempre do seu cadastro ou da ficha do contato, nunca é adivinhada.',
        ],
    },
    {
        key: 'resumo_grupos',
        name: 'O que eu perdi',
        shortDescription: 'Resume os grupos que você escolher, sem você precisar ler tudo.',
        description: 'Resume em poucas linhas o que aconteceu nos grupos que você escolher acompanhar, como família, condomínio e trabalho.',
        accentColor: '#7C3AED',
        theme: 'chat-bubble',
        lifecycle: 'planned',
        mascot: { key: 'esp-grupos', name: 'Eco' },
        ownerCommandExamples: ['O que rolou no grupo da família hoje?'],
        capabilities: [
            'Destaques separados por grupo.',
            'Você escolhe exatamente quais conversas entram no resumo.',
        ],
        friendlyRules: ['Organizo para você e nunca respondo no grupo por conta própria.'],
    },
    {
        key: 'radar_precos',
        name: 'Radar de preços',
        shortDescription: 'Compara o preço atual com o valor que vale a compra.',
        description: 'Você registra um produto, o preço encontrado e seu valor-alvo. Eu guardo a linha do tempo, destaco as quedas e aviso quando o preço entra na faixa escolhida.',
        accentColor: '#EA580C',
        theme: 'price-tag',
        lifecycle: 'available',
        mascot: { key: 'esp-radar', name: 'Radar' },
        ownerCommandExamples: ['Fica de olho numa airfryer até R$ 300'],
        capabilities: [
            'Histórico visual para comparar cada produto.',
            'Destaque quando o valor entra na faixa que você escolheu.',
        ],
        friendlyRules: ['Nunca inventa promoção nem trata preço antigo como oferta atual.'],
    },
    {
        key: 'lista_compras',
        name: 'Lista de compras',
        shortDescription: 'O que falta, separado por corredor e fácil de marcar.',
        description: '"Acabou o café" entra na lista; no mercado, os itens aparecem grandes, separados por setor e marcáveis com um toque, com quantidade, observação e estimativa opcional.',
        accentColor: '#65A30D',
        theme: 'cart',
        lifecycle: 'available',
        mascot: { key: 'esp-compras', name: 'Feira' },
        ownerCommandExamples: ['Acabou o café', 'Me fala minha lista de compras'],
        capabilities: [
            'Adiciona e consulta por voz ou texto.',
            'Modo mercado, estimativa e compartilhamento pelo celular.',
        ],
        friendlyRules: ['A lista fica protegida na sua conta e só muda quando você pede.'],
    },
    {
        key: 'retrospectiva',
        name: 'Retrospectiva do mês',
        shortDescription: 'Um resumo bonito e compartilhável do que o Secretário fez por você.',
        description: 'No fim do mês, você recebe um retrato bonito do tempo poupado, das rotinas cuidadas e dos momentos em que a equipe ajudou.',
        accentColor: '#DB2777',
        theme: 'sparkles',
        lifecycle: 'planned',
        mascot: { key: 'esp-retro', name: 'Retrô' },
        ownerCommandExamples: [],
        capabilities: ['Resumo visual do mês.', 'Uma lembrança bonita para guardar ou compartilhar.'],
        friendlyRules: [],
    },
    {
        key: 'passagens',
        name: 'Caçador de passagens',
        shortDescription: 'Fica de olho no preço da passagem pro destino que você quiser.',
        description: 'Acompanha o destino e o período que você escolher, compara as mudanças de preço e destaca quando surgir uma boa oportunidade.',
        accentColor: '#0891B2',
        theme: 'plane',
        lifecycle: 'planned',
        mascot: { key: 'esp-passagens', name: 'Voa' },
        ownerCommandExamples: ['Me avisa de passagem pra Lisboa em março'],
        capabilities: [
            'Visão de preços por período.',
            'Aviso quando a passagem entrar na faixa que você escolher.',
        ],
        friendlyRules: [
            'Toda oportunidade mostra data, condições e caminho para você conferir antes de decidir.',
        ],
    },
];
export function findSpecialist(key) {
    return SPECIALIST_CATALOG.find((specialist) => specialist.key === key);
}
